// Shared ordering and filtering for every contact role picker (owner feedback 9 Oct 2026, #2 and #13).
export type RoleChoice = {code: string; label: string; category?: string | null};

/** Roles most often chosen for a contact; only those offered by the catalogue are shown. */
export const commonRoleCodes = ['primary_client_contact', 'board_director_contact', 'building_representative', 'leaseholder', 'solicitor', 'legal_adviser', 'surveyor', 'contractor', 'accountant'];

/** Groups roles by category in the order the catalogue lists them (role_definitions.display_order). */
export function groupRoles<T extends RoleChoice>(roles: T[], fallback = 'Other') {
  const groups: {category: string; roles: T[]}[] = [];
  for (const role of roles) {
    const category = role.category || fallback, group = groups.find(item => item.category === category);
    if (group) group.roles.push(role); else groups.push({category, roles: [role]});
  }
  return groups;
}

/** Roles shown under "More roles" for a filter: matching labels, plus every checked role so a choice never disappears. */
export function filterRoles<T extends RoleChoice>(roles: T[], query: string, selected: string[]) {
  const text = query.trim().toLowerCase();
  return text ? roles.filter(role => selected.includes(role.code) || role.label.toLowerCase().includes(text)) : roles;
}
